import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as B from './Profile.styles';
import defaultProfileImg from 'assets/MemberImage/defaultProfileImage.png';
import { memberService, MemberInfo } from 'services/memberService';
import { reservationService, ReservationInUse } from 'services/reservationService';

const CarouselG: React.FC = () => {
  const isGuest = localStorage.getItem("guestMode") === "true";
  const [userInfo, setUserInfos] = useState<MemberInfo>({
    profileImage: null,
    name: "",
    studentId: "",
    department: "",
    university: { id: 0, name: "" }
  });
  const [ReservationInfo, setReservationInfo] = useState<ReservationInUse | null>(null);
  const [remainingTime, setRemainingTime] = useState<string>('');

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const data = await memberService.getMe();
        setUserInfos(data);
      } catch (error) {
        console.error('Failed to fetch user info:', error);
        setUserInfos({
          profileImage: null,
          name: "",
          studentId: "",
          department: "",
          university: { id: 0, name: "" }
        });
      }
    };
    fetchUserInfo();
  }, []);

  useEffect(() => {
    const fetchReservationInfo = async () => {
      try {
        const data = await reservationService.getInUseReservation();
        setReservationInfo(data);
      } catch (error) {
        console.error('Error fetching reservation info:', error);
        setReservationInfo(null);
      }
    };
    fetchReservationInfo();
  }, []);

  useEffect(() => {
    if (!ReservationInfo) {
      setRemainingTime('');
      return;
    }

    const calculateRemainingTime = () => {
      const startTime = new Date(ReservationInfo.startTime);
      const endTime = new Date(startTime.getTime() + ReservationInfo.durationMinutes * 60000);
      const now = new Date();
      const diff = endTime.getTime() - now.getTime();

      if (diff <= 0) {
        setRemainingTime('종료됨');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setRemainingTime(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    };

    calculateRemainingTime();
    const interval = setInterval(calculateRemainingTime, 1000);

    return () => clearInterval(interval);
  }, [ReservationInfo]);

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <B.CarouselContainer>
      <Slider {...settings}>
          <div>
            <B.ProfileBox>
              <B.img>
                <img className="img1" alt="프로필이미지" src={userInfo.profileImage || defaultProfileImg} referrerPolicy="no-referrer" />
                <div>
                  <B.Title>
                    {isGuest ? (
                      <B.Name>로그인이 필요해요</B.Name>
                    ) : (
                      <>
                        <B.Name>{userInfo.name}</B.Name>
                        <B.Sub>님</B.Sub>
                      </>
                    )}
                  </B.Title>
                  <B.ClassInfo>
                    {isGuest ? '회원가입하고 더 많은 기능을 이용해보세요' : `${userInfo.university.name} ${userInfo.department}`}
                  </B.ClassInfo>
                </div>
              </B.img>
              <B.Reservation>
                <Link to={isGuest ? "/login" : "/reservations"} style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                  <B.Left>{isGuest ? '로그인' : '예약내역'}</B.Left>
                </Link>
                <B.VerticalBorder />
                <Link to={isGuest ? "/signup" : "/reservation"} style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                  <B.Right>{isGuest ? '회원가입' : '예약하기'}</B.Right>
                </Link>
              </B.Reservation>
            </B.ProfileBox>
          </div>
          <div>
            {ReservationInfo ? (
              <B.InUseBox>
                <B.InUseHeader>
                  <B.FacilityImage
                    src={ReservationInfo.facility.imageUrl || defaultProfileImg}
                    alt="시설 이미지"
                    referrerPolicy="no-referrer"
                  />
                  <B.InUseInfo>
                    <B.InUseNameRow>
                      <B.InUseFacilityName>{ReservationInfo.facility.name}</B.InUseFacilityName>
                      <B.InUseStatus>이용 중</B.InUseStatus>
                    </B.InUseNameRow>
                    <B.InUseTime>남은 시간 {remainingTime}</B.InUseTime>
                  </B.InUseInfo>
                </B.InUseHeader>
                <B.InUseButtons>
                  <Link to={`/return/${ReservationInfo.id}`} style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                    <B.InUseButtonLeft>반납하기</B.InUseButtonLeft>
                  </Link>
                  <B.InUseButtonDivider />
                  <Link to={`/extension/${ReservationInfo.id}`} style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                    <B.InUseButtonRight>연장하기</B.InUseButtonRight>
                  </Link>
                </B.InUseButtons>
              </B.InUseBox>
            ) : (
              <B.ProfileBox style={{ backgroundColor: '#f1fff3' }}>
                <B.Phrase>현재 이용 중인 시설이 없습니다.</B.Phrase>
                <B.Reservation style={{ backgroundColor: '#1fbc70', height: '48px', marginTop: '20px' }}>
                  <Link to="/reservations" style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                    <B.Left style={{ color: '#ffffff' }}>예약내역</B.Left>
                  </Link>
                  <B.VerticalBorder />
                  <Link to="/reservation" style={{ flex: 1, display: 'flex', textDecoration: 'none', height: '100%' }}>
                    <B.Right style={{ color: '#ffffff' }}>예약하기</B.Right>
                  </Link>
                </B.Reservation>
              </B.ProfileBox>
            )}
          </div>
      </Slider>
    </B.CarouselContainer>
  );
};

export default CarouselG;
